import { LocalPersistence } from '../../factories/index';

type BreadcrumbSession = {
  session: {
    supplier: string;
    propertyName: string;
  };
  path: boolean;
};

const breadcrumbSession: () => Promise<BreadcrumbSession> = async () => {
  try {
    const { pathname } = window.location;
    const get_session: LocalPersistence = new LocalPersistence('session');
    const session: Promise<{ session: { supplier: string } }> =
      await get_session.getSessionPersistence();
    const breadcrumbsWhiteList = [
      '/listing',
      '/rolelist',
      '/userManagement',
      '/reports',
    ];
    const path: boolean = breadcrumbsWhiteList.includes(pathname);
    let userInfo = {};
    // removing first item of whitelist
    breadcrumbsWhiteList.shift();
    // if is user route
    if (breadcrumbsWhiteList.includes(pathname)) {
      switch (pathname) {
        case '/userManagement':
          userInfo = {
            view: true,
            title: 'User Management',
            subValue: 'User',
            value: 'User List',
          };
          break;
        case '/rolelist':
          userInfo = {
            view: true,
            title: 'Roles',
            subValue: 'Roles',
            value: 'Role List',
          };
          break;
        case '/reports':
          userInfo = {
            view: true,
            title: 'Reports',
          };
          break;
        default:
          return '';
      }
    }
    return { path, session, userInfo };
  } catch (error: any) {
    return error;
  }
};

export { breadcrumbSession };
